import { CurrencyInput } from 'ui-components/components/currency-input';

import type { Currency } from '../../prop-types/currency';

type ReadonlyInsuredAmountProps = {
  insuredAmount: Currency;
  className?: string | undefined;
  disabled?: boolean;
  currencySymbolClassName?: string;
};

export const ReadonlyInsuredAmount = ({
  className,
  disabled = false,
  insuredAmount,
  currencySymbolClassName,
}: ReadonlyInsuredAmountProps) => {
  const { value, code } = insuredAmount;
  return (
    <CurrencyInput
      className={className}
      currencyCode={code}
      currencySymbolClassName={currencySymbolClassName}
      data-testid='readonly-insured-amount'
      disabled={disabled}
      value={value}
    />
  );
};
